// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popup-wrap .popup-box .commercial_img{\n  border-radius: 10px;\n  width: 100%;\n\tmin-width: 260px;\n\tmax-width: 356px;\n  aspect-ratio: 89 / 150;\n}\n", ""]);
// Exports
module.exports = exports;
